import React from 'react';
import { Card } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import AuditStatusInfo from '../components/AuditStatusInfo';

const SystemLogInfo = ({ data }) => {
  return (
    <Card>
      <table className="table table-hover">
        <tbody>

          <tr>
            <td className="pr-3">Id</td>
            <td>{ data.id }</td>
          </tr>

          <tr>
            <td className="pr-3">Cliente id</td>
            <td>{ data.cliente_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Empresa id</td>
            <td>{ data.empresa_id }</td>
          </tr>

          { Guardian.allows('root.access') && (
            <tr>
              <td>Pac</td>
              <td>{ data.pac }</td>
            </tr>
          )}

          <tr>
            <td className="pr-3">Entity id</td>
            <td>{ data.entity_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Entry type</td>
            <td>{ data.entry_type }</td>
          </tr>

          <tr>
            <td className="pr-3">Status</td>
            <td>
              <AuditStatusInfo status={ data.status } />
            </td>
          </tr>
          <tr>
            <td className="pr-3">Time</td>
            <td>{ data.time }</td>
          </tr>
          <tr>
            <td className="pr-3">Status reason</td>
            <td>{ data.status_reason }</td>
          </tr>
          <tr>
            <td className="pr-3">Method</td>
            <td>{ data.method }</td>
          </tr>
          <tr>
            <td className="pr-3">Route</td>
            <td>{ data.route }</td>
          </tr>
          <tr>
            <td className="pr-3">Ip address</td>
            <td>{ data.ip_address }</td>
          </tr>
          <tr>
            <td className="pr-3">User agent</td>
            <td>{ data.user_agent }</td>
          </tr>

          <tr>
            <td className="pr-3">User id</td>
            <td>{ data.user_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Created at</td>
            <td>{ data.created_at }</td>
          </tr>

        </tbody>
      </table>
    </Card>
  )
}

export default SystemLogInfo;